import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleObject } from "styletron-react"
import { frames, icons, useMediaQuery } from "../../Styles"
import { CoreNavLink } from "../../Components"
import { NavLinkTypes } from "../../Definitions"
import { GlobalMenu_Pages } from "../pages"

const navItems = [
  { page: GlobalMenu_Pages.dashboard, icon: icons.dashboard, disabled: true },
  { page: GlobalMenu_Pages.kpi, icon: icons.kpi },
  { page: GlobalMenu_Pages.feedCurves, icon: icons.feedCurves },
  { page: GlobalMenu_Pages.silos, icon: icons.silos, disabled: true },
  { page: GlobalMenu_Pages.animals, icon: icons.animals },
  { page: GlobalMenu_Pages.reports, icon: icons.reports },
  { page: GlobalMenu_Pages.logbook, icon: icons.logBook },
  { page: GlobalMenu_Pages.globalSettings, icon: icons.globalSettings },
]
interface GlobalMenu_Props {
  overrides?:{
      gridArea?: string
  }
}

export default function GlobalMenu({overrides}:GlobalMenu_Props) {
  const {t} = useTranslation()
  const groupMenu2columns = useMediaQuery(`(max-width: 454px), (min-width: 1000px)`)
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`)

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject,
      overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])

  return (
    <frames.GlobalMenu $style={_Root}>
      <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px", display: "flex", flexWrap: "wrap", justifyContent: "start", gap: "5px"}}>
        {navItems.map(({ page, icon, disabled }) => {
          const label = t(`menuHeaders.${page}`, { defaultValue: page })

          return (
            <CoreNavLink
              key={page}
              content={label}
              path={page}
              endPath={false}
              icon={icon}
              navLinkType={NavLinkTypes.globalMenuNavLink}
              disabled={disabled}
            />
          )
        })}
      </div>
    </frames.GlobalMenu>
  )

}